'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "children"];
import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { useRenderElement } from '@mui/x-scheduler-headless/base-ui-copy';
import { schedulerOccurrenceSelectors } from '@mui/x-scheduler-headless/scheduler-selectors';
import { useEventTimelinePremiumStoreContext } from "../../use-event-timeline-premium-store-context/index.mjs";
import { eventTimelinePremiumViewSelectors } from "../../event-timeline-premium-selectors/index.mjs";
export const TimelineGridSubGrid = /*#__PURE__*/React.forwardRef(function TimelineGridSubGrid(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      children: childrenProp
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);

  // Context hooks
  const store = useEventTimelinePremiumStoreContext();

  // Selector hooks
  const viewConfig = useStore(store, eventTimelinePremiumViewSelectors.config);
  const resources = useStore(store, schedulerOccurrenceSelectors.groupedByResourceList, viewConfig.start, viewConfig.end);
  const children = React.useMemo(() => {
    if (! /*#__PURE__*/React.isValidElement(childrenProp) && typeof childrenProp === 'function') {
      return resources.map(({
        resource
      }) => childrenProp(resource.id));
    }
    return childrenProp;
  }, [childrenProp, resources]);
  const props = {
    role: 'rowgroup',
    children
  };
  return useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [props, elementProps]
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridSubGrid.displayName = "TimelineGridSubGrid";